<template>
  <createContent/>
</template>

<script>
import createContent from '@/components/_managebusinessnew/_update/update.vue'
export default {
  components: {
    createContent
  }
}
</script>
